<template>
  <div class="role-select-wrapper w-100 h-100" :class="{invalid: invalid}">
    <el-tree-select
        class="w-100 h-100"
        :placeholder="placeholder"
        v-model="formattedValue"
        :data="roleList"
        :check-strictly="true"
        :render-after-expand="false"
        :filter-node-method="filterNodeMethod"
        :default-expand-all="true"
        :props="{children: 'sub', label: 'name'}"
        node-key="id"
        filterable
    />
  </div>
</template>
<script>
// 角色选择器：用于选择角色，只能单选，显示树形结构
import {roleList, getPartnerRoles} from "@/service";
import i18n from "@/i18n";
import { CAN_ROLE } from "@/config/common.js";
export default {
  props: {
    type: {
      type: String,
      default: 'user', // user-普通用户 organization-企业用户
    },
    belong_type: {
      type: String,
      default: null,
    },
    value: {
      type: [String, Number],
      default: null,
    },
    invalid: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: i18n.global.t('page.please-select-role'),
    },
  },
  emits: [
    'loaded', // 列表加载完成
    'changed'
  ],
  mounted() {
    this.getRoleList();
  },
  data() {
    return {
      CAN_ROLE,
      roleList: [],
      roleListLoading: false,
      formattedValue: this.value,
    };
  },
  methods: {
    getRoleList() {
      this.roleListLoading = true;
      if (this.type === 'user') {
        roleList().then(res => {
          this.roleListLoading = false;
          this.roleList = res.payload;       
          this.translateTree(this.roleList[0])
        }).finally(()=>{
          this.$emit("loaded", this.roleList);
        })
      } else {
        getPartnerRoles(this.belong_type).then(res => {
          this.roleListLoading = false;
          this.roleList = res.payload;       
          this.translateTree(this.roleList[0])
        }).finally(()=>{
          this.$emit("loaded", this.roleList);
        })
      }
    },
    translateTree(node) {  
          // 先对当前节点的 name 进行翻译
          // const i18Roles = ["代理商","工程师","基本用户","客户","设备联系人","管理员"] 
          if(CAN_ROLE.includes(node.name)){
            node.name = i18n.global.t(`page.role-management['${node.name}']`);  
          }
        
          // 检查当前节点是否有子节点  
          if (node.sub) {  
              // 遍历每个子节点，并递归调用 translateTree  
              node.sub.forEach(child => {  
                  this.translateTree(child);  
              });  
          }    
    },
    filterNodeMethod(value, data) {
      if (!value) return true;
      return data.name.includes(value);
    },
    clearSelect() {
      this.formattedValue = null;
    },
  },
  watch: {
    formattedValue(val) {
      this.$emit("changed", val);
    },
  },
}
</script>
<style>
.el-input__wrapper {
  padding: 4px 11px;
}
.role-select-wrapper.invalid .el-select .el-input .el-input__wrapper {
  box-shadow: 0 0 0 1px #f06548 inset!important;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23f06548'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23f06548' stroke='none'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.25rem) center;
  background-size: calc(0.75em + 0.5rem) calc(0.75em + 0.5rem);
}
</style>
